import { Gift } from "lucide-react";
import { cn } from "@/lib/utils";
import { useLanguage } from "@/contexts/LanguageContext";
import { useReferralBonusBanner } from "./useReferralBonusBanner";

interface ReferralBonusBannerProps {
  className?: string;
}

/**
 * Persistent nudge shown to a referred-but-not-yet-rewarded user at the
 * subscription decision points (pricing page + paywall modal): subscribing to a
 * paid plan grants bonus credits to BOTH them and their referrer. Self-hides
 * once the user subscribes (the referral flips pending → rewarded server-side).
 */
export function ReferralBonusBanner({ className }: ReferralBonusBannerProps) {
  const { t } = useLanguage();
  const pending = useReferralBonusBanner();

  if (!pending?.pending) return null;

  const credits = String(pending.bonusCredits ?? "");
  const text = pending.referrerName
    ? t.referral.subscribeBannerText
        .replace("{name}", pending.referrerName)
        .replace("{credits}", credits)
    : t.referral.subscribeBannerTextGeneric.replace("{credits}", credits);

  return (
    <div
      className={cn(
        "flex items-center justify-center gap-2 rounded-xl border border-primary/30 bg-primary/10 px-4 py-3 text-sm font-medium text-foreground",
        className,
      )}
    >
      <Gift className="w-4 h-4 text-primary shrink-0" />
      <span>{text}</span>
    </div>
  );
}
